import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './home.html',
  styleUrls: ['./home.scss'],
})
export class HomeComponent {
  features = [
    {
      icon: '🏢',
      title: 'Gestion empresarial',
      description: 'Optimice la verificacion de empresas y los procesos de cumplimiento',
    },
    {
      icon: '👤',
      title: 'Debida diligencia',
      description: 'Verificacion integral de clientes y evaluacion de riesgos',
    },
    {
      icon: '📋',
      title: 'Cuestionarios inteligentes',
      description: 'Cuestionarios dinamicos para una recoleccion eficiente de datos',
    },
    {
      icon: '🔍',
      title: 'Matriz de riesgo',
      description: 'Herramientas avanzadas de evaluacion y monitoreo de riesgos',
    },
    {
      icon: '🏛️',
      title: 'Supervision organizacional',
      description: 'Gestion completa de la estructura organizacional',
    },
    {
      icon: '✅',
      title: 'Listo para cumplimiento',
      description: 'Cumpla con las regulaciones internacionales de KYC',
    },
  ];
}
